var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiFileRemovingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.001,
    height: 24,
    viewBox: "0 0 88.001 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161754",
    "data-name": "Group 161754",
    transform: "translate(-76 -284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161742",
    "data-name": "Group 161742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1222",
    "data-name": "Rectangle 1222",
    transform: "translate(76 284)",
    fill: "rgba(233,185,254,0.62)",
    stroke: "#d07af7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88.001,
    height: 24,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87.001,
    height: 23,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_83728",
    "data-name": "Path 83728",
    d: "M8.237,12H9.29V8.321h1.989L13.294,12h1.222L12.384,8.217a2.692,2.692,0,0,0,1.9-2.626A2.647,2.647,0,0,0,11.318,2.9H8.237ZM9.29,7.385V3.836h1.963A1.732,1.732,0,0,1,13.19,5.591a1.7,1.7,0,0,1-1.872,1.794Zm9.841,4.784a3.131,3.131,0,0,0,3.146-2.158H21.211a2.143,2.143,0,0,1-2.067,1.222A2.181,2.181,0,0,1,16.83,8.984h5.512V8.529a3.2,3.2,0,0,0-3.276-3.458A3.31,3.31,0,0,0,15.751,8.62,3.308,3.308,0,0,0,19.131,12.169Zm-2.275-4.1a2.194,2.194,0,0,1,2.21-2.067A2.085,2.085,0,0,1,21.25,8.074ZM24.162,12h1.027V7.931a1.785,1.785,0,0,1,1.755-1.9,1.618,1.618,0,0,1,1.677,1.729V12h1.027V7.97a1.771,1.771,0,0,1,1.781-1.937c1,0,1.638.65,1.638,1.924V12h1.027V7.619a2.392,2.392,0,0,0-2.483-2.548,2.227,2.227,0,0,0-2.145,1.235h-.091a2.282,2.282,0,0,0-2.132-1.235,2.129,2.129,0,0,0-1.976,1.144h-.078V5.24H24.162Zm15.145.169A3.455,3.455,0,0,0,42.843,8.62a3.53,3.53,0,1,0-7.059,0A3.429,3.429,0,0,0,39.307,12.169Zm0-.936a2.45,2.45,0,0,1-2.47-2.613,2.48,2.48,0,1,1,4.953,0A2.46,2.46,0,0,1,39.307,11.233ZM46.34,12h1.066l2.665-6.76H48.94l-2.028,5.5h-.078l-2.041-5.5h-1.1Zm5.824-7.982a.731.731,0,0,0,.754-.754.748.748,0,0,0-1.495,0A.728.728,0,0,0,52.164,4.018ZM51.631,12h1.027V5.24H51.631Zm3.237,0h1.027V7.97a1.877,1.877,0,0,1,1.9-1.937,1.711,1.711,0,0,1,1.742,1.781V12h1.027V7.749A2.485,2.485,0,0,0,58.04,5.071a2.207,2.207,0,0,0-2.067,1.157h-.078V5.24H54.868Zm10.868,3.159A2.974,2.974,0,0,0,69.025,12V5.24H68V6.332H67.92a2.768,2.768,0,0,0-2.379-1.261,3.309,3.309,0,0,0-3.289,3.562,3.31,3.31,0,0,0,3.367,3.536,2.767,2.767,0,0,0,2.34-1.235h.078V12a2.048,2.048,0,0,1-2.3,2.262c-1,0-1.781-.416-1.963-1.209H62.8A2.723,2.723,0,0,0,65.736,15.159Zm-.052-3.913A2.361,2.361,0,0,1,63.3,8.633a2.379,2.379,0,1,1,4.732,0A2.4,2.4,0,0,1,65.684,11.246Z",
    transform: "translate(81.763 288)",
    fill: "#d07af7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFileRemovingIcon);
export default __webpack_public_path__ + "static/media/ai-file-removing-icon.94d67056ab6995158e710284ef4cc3de.svg";
export { ForwardRef as ReactComponent };